var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ods-main-navigation',{ref:"navigation",attrs:{"navigation":_vm.navOptions}},[_c('template',{slot:"suites"},[_c('suites-menu')],1),_c('template',{slot:"isPhone-user-menu"},[_c('user-menu',{staticClass:"is-phone__user-menu"})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }